module.exports = __webpack_public_path__ + "/build/web/images/fabrics/agde-17@3x.b82f8873f2af884bcfabafe53b3cf32a.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/fabrics/agde-17@3x.jpg
// module id = 132
// module chunks = 13